import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';

@Component({
  selector: 'app-register-main',
  // standalone: true,
  // imports: [],
  templateUrl: './register-main.component.html',
  styleUrl: './register-main.component.css',
})
export class RegisterMainComponent {
  showRegistration = false;
  showTallerForm = false;
  showCompanyPlate = false;
  hoverTaller = false;
  hoverEmpresa = false;

  constructor(
    private router: Router,
    private analitycs: AnalitycsService,
  ) {
    // do nothing
  }

  toggleRegistration() {
    this.showRegistration = !this.showRegistration;
    this.showTallerForm = false;
    this.showCompanyPlate = false;
  }

  register(type: 'taller' | 'empresa') {
    if (type === 'taller') {
      this.showTallerForm = true;
      this.showCompanyPlate = false;
    } else {
      this.showTallerForm = false;
      this.showCompanyPlate = true;
    }
  }
  goWorkshopForm() {
    this.analitycs.logEvent('ir_a_formulario_taller', {
      pantalla: 'register-main',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.router.navigate(['workshop-form']);
  }
  goRegister() {
    this.analitycs.logEvent('ir_a_registro_de_usuario_desde_register-main', {
      pantalla: 'register-main',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.router.navigate(['/register']);
  }
  toggleLoggin() {
    this.analitycs.logEvent('ir_a_login_de_usuario_desde_register-main', {
      pantalla: 'register-main',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.router.navigate(['/login']);
  }
  toggleHome() {
    this.analitycs.logEvent('ir_a_home_desde_register-main', {
      pantalla: 'register-main',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.router.navigate(['/']);
  }
}
